<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<p style="text-align: center;margin-top:150px;">“…Light thickens, and the crow</p>
<p style="text-align: center;">Makes wing to th’ rooky wood.</p>
<p style="text-align: center;">Good things of day begin to droop and drowse,</p>
<p style="text-align: center;">Whiles night’s black agents to their preys do rouse.”</p>
<p style="text-align: right;">—Shakespeare</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?fa0e80ca